<template>
  <div>
    <section
      id="theSlide"
      style="height: 490px; padding-left:  75px; padding-right: 75px;     margin-top: 30px;"
    >
      <div class="clear"></div>
      <div class="row">
        <div class="col-lg-12 col-md-12 col-12" style="margin: 0 auto;">
          <hooper
            :autoPlay="false"
            :mouseDrag="false"
            :playSpeed="15000"
            :transition="1000"
            :infiniteScroll="false"
            :centerMode="true"
            :shortDrag="false"
            :touchDrag="false"
            :wheelControl="false"
          >
            <slide style="background-color:#333; height: fit !important;">
              <img :src="getFullPath('slide_image1.jpg')" alt="Image" />
            </slide>
            <!-- <slide style="background-color:#333; height: fit !important;">
              <img :src="getFullPath('slide_image2.jpg')" alt="Image" />
            </slide>
            <slide style="background-color:#555; max-height: 490px;">
              <img :src="getFullPath('slide_image3.jpeg')" alt="Image" />
            </slide> -->
            <!-- <slide style="background-color:#444;">
              <img :src="getFullPath('slide_image4.jpg')" alt="Image" />
            </slide>
            <slide style="background-color:#555;">
              <img :src="getFullPath('wintershop_v3_4.jpg')" alt="Image" />
            </slide> -->

            <hooper-navigation slot="hooper-addons"></hooper-navigation>
            <hooper-pagination slot="hooper-addons"></hooper-pagination>
          </hooper>
        </div>
      </div>
    </section>

    <Category> </Category>
    <div class="clear"></div>

    <section id="content" style="margin-top:60px;">
      <div class="content-wrap">
        <div class="padding-responsive">
          <!-- Hot Items -->
          <div class="row" style="margin-top: 50px;">
            <div class="col-lg-10 col-md-10 col-10" style="text-align:left;">
              <h4 class="title-font" style=" margin-bottom: 0;">Hot Items</h4>
            </div>
            <div class="col-lg-10 col-md-10 col-10" style="text-align:left; ">
              <h3
                style="font-size: 20px; font-family:'supermarket'; color: #bcbcbd; margin-bottom: 0;"
              >
                สินค้าเป็นที่นิยม
              </h3>
            </div>
          </div>
          <div class="clear"></div>

          <!-- HOT ITEMS :: ITEM LIST -->
          <div
            class="row rowdata1 grid-6"
            style="max-width: 1100px; margin-left:auto; margin-right: auto;"
          >
            <div
              v-for="(item, ind) in items"
              :key="ind"
              class="col-lg-3 col-md-3 col-6"
            >
              <div
                class="product iproduct clearfix imagefocus"
                style="border: 1px solid #f0f0f0;"
              >
                <form action="shop-single.html">
                  <div class="product-image" style="height: 250px; ">
                    <!-- <a href="javascript:sendData('{{ item.productItemId }}')"><img :src="getFullPath(item.mainImage)" alt="Image 2"></a> -->
                    <img
                      :src="getProductPath(item.mainImage)"
                      alt="Image 2"
                      style="width:85%; margin: 10px auto; height:auto; cursor:pointer;"
                      @click="moveTo(item.productGroupId)"
                    />
                  </div>
                  <div class="product-desc">
                    <!-- <input type="hidden" name="wproduct" :value="getProductID(item.productGroupId)" /> -->
                    <input
                      type="submit"
                      :value="getProductName(item.name)"
                      style="    border: 0; font-family:'mitr-regular' !important;
											background-color: white;     display: flex; margin: auto;"
                    />

                    <!-- <div class="product-title mb-1"><h3><a href="#">{{ item.name }}</a></h3></div> -->
                    <div class="product-price font-primary">
                      <ins>{{ formatPrice(item.rentalPrice) }} บาท</ins>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <!-- HOT ITEMS :: ITEM LIST -->
          <!-- New Arrivals -->
          <div class="row" style="margin-top: 50px;">
            <div class="col-lg-10 col-md-10 col-10" style="text-align:left;">
              <h4 class="title-font" style="margin-bottom: 0;">New Arrivals</h4>
            </div>
            <div class="col-lg-10 col-md-10 col-10" style="text-align:left; ">
              <h3
                style="font-size: 20px; font-family:'supermarket'; color: #bcbcbd; margin-bottom: 0;"
              >
                สินค้ามาใหม่
              </h3>
            </div>
          </div>
        </div>
        <!-- padding-responsive -->
      </div>
      <!-- content-wrap -->
    </section>

    <div class="clear"></div>

    <!-- NEW ARRIVALS :: ITEM LIST -->
    <div
      class="row rowdata1 grid-6"
      style="max-width: 1100px; margin-left:auto; margin-right: auto;"
    >
      <div
        v-for="(item, ind) in newArrival"
        :key="ind"
        class="col-lg-3 col-md-3 col-6"
      >
        <div
          class="product iproduct clearfix imagefocus"
          style="border: 1px solid #f0f0f0;"
        >
          <form action="shop-single.html">
            <div class="product-image" style="height: 250px; ">
              <!-- <a href="javascript:sendData('{{ item.productItemId }}')"><img :src="getFullPath(item.mainImage)" alt="Image 2"></a> -->
              <img
                :src="getProductPath(item.mainImage)"
                alt="Image 2"
                style="width:85%; margin: 10px auto; height:auto; cursor:pointer;"
                @click="moveTo(item.productGroupId)"
              />
            </div>
            <div class="product-desc">
              <!-- <input type="hidden" name="wproduct" :value="getProductID(item.productGroupId)" /> -->
              <input
                type="submit"
                :value="getProductName(item.name)"
                style="    border: 0; font-family:'mitr-regular' !important;
											background-color: white;     display: flex; margin: auto;"
              />
              <!-- <div v-if="namelen(item.name) > 24" >
                   
                  <VTextMarquee :speed="20" >
                    {{getProductName(item.name)}}
                  </VTextMarquee> 
              </div>
              <div v-else>
                {{getProductName(item.name)}}
              </div> -->
              <div>{{ limitText(item.name, 22) }}</div>

              <!-- <div class="product-title mb-1"><h3><a href="#">{{ item.name }}</a></h3></div> -->
              <div class="product-price font-primary">
                <ins>{{ formatPrice(item.rentalPrice) }} บาท</ins>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
    <!-- NEW ARRIVALS :: ITEM LIST -->
    <div class="clear bottommargin-sm"></div>

    <div
      class="row topmargin clearfix"
      style="margin-left:auto; margin-right:auto; max-width: 1100px; margin-bottom: 40px;"
    >
      <div id="features">
        <img
          :src="getFullPath('why.png')"
          style=" width: 100%;  height: auto !important;"
        />
      </div>
    </div>

    <!-- row -->
  </div>

  <!-- ROOT -->
</template>

<script>
// @ is an alias to /src
// import carousel from "vue-owl-carousel";
// import Slide from "@/views/Slide.vue";

// import store from "@/store.js";
import axios from "axios";
import {
  Hooper,
  Slide,
  Navigation as HooperNavigation,
  Pagination as HooperPagination,
} from "hooper";

import store from "@/store";

import Category from "./Category.vue";

import "hooper/dist/hooper.css";
import myMixins from "@/mixins/myMixins.js";
export default {
  name: "home",
  mixins: [myMixins],
  data() {
    return {
      open: false,
      // overlay: true,
      // fullheight: true,
      // fullwidth: false,
      // right: false,

      newArrival: [],
      api: store.state.apiUrl,
      items: [],
      data: [
        '<div class="example-slide">Slide 1</div>',
        '<div class="example-slide">Slide 2</div>',
        '<div class="example-slide">Slide 3</div>',
      ],
    };
  },
  watch: {
    open() {
      console.log("this.open >>>> ", this.open);
    },
  },
  methods: {
    theOpen() {
      this.open = true;
    },
    openLoading() {
      this.isLoading = true;
      setTimeout(() => {
        this.isLoading = false;
      }, 10 * 1000);
    },
    // getProductPath(mainImage) {
    //   if (mainImage === undefined || mainImage === null || mainImage === "") {
    //     return store.state.imageUrl + "defaultimage.png";
    //   } else {
    //     return "https://wintershop-online.com/webimage/item/" + mainImage;
    //   }
    // },
    // getFullPath(mainImage) {
    //   if (mainImage === undefined || mainImage === null || mainImage === "") {
    //     return store.state.imageUrl + "defaultimage.png";
    //   } else {
    //     return store.state.imageUrl + mainImage;
    //   }
    // },
    // getLinkItem(productid) {

    //   return this.api + "/api/catalog/getitem/" + productid;
    // },
    getProductID(productid) {
      return productid;
    },
    getProductName(productname) {
      let txt = this.limitText(productname, 24);
      return txt;
    },
  },
  mounted() {
    var api_url = this.api + "/web-api/web/grouplist";
    axios.post(api_url, {}, store.state.apiHeader).then((response) => {
      this.items = response.data.filter((x) => x.webHotItem === "ใช่");
      this.newArrival = response.data.filter((x) => x.webNewArrival === "y");
    });

    window.scrollTo(0, 0);
  },
  components: {
    Hooper,
    Slide,
    HooperNavigation,
    HooperPagination,
    Category,
  },
};
</script>

<style>
.title-font {
  font-size: 2.5rem;
}

.hooper-slide {
  width: 100% !important;
  background-color: white !important;
}

.hooper {
  height: auto !important;
  max-width: 1150px;
  margin-left: auto;
  margin-right: auto;
}

.p-1 {
  padding: 1em;
}

.padding-responsive {
  margin-left: 56px;
  margin-right: 56px;
}

/**** ถ้าเป็นของร้านอื่นต้องลบออก ****/
/* .icon-arrowLeft{
  display: none !important;
}

.icon-arrowRight{
  display: none !important;
}

.hooper-indicator{
  display: none !important;
} */

/**** ถ้าเป็นของร้านอื่นต้องลบออก ****/

/* New rules if the window width is smaller than 1024px */
@media only screen and (max-width: 578px) {
  .title-font {
    font-size: 1.9rem;
  }
  #theSlide {
    height: 250px !important;
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
  .padding-responsive {
    margin-left: 0;
    margin-right: 0;
  }

  .nosmpadding {
    padding-left: 0 !important;
  }

  .imagefocus {
    height: 270px !important;
    margin-top: 20px !important;
  }

  .product-image {
    height: 170px !important;
  }
  .product-desc {
    font-size: 0.9rem !important;
    font-family: "mitr-regular" !important;
    padding-left: 0 !important;
  }
  .product-price {
    font-size: 0.9rem !important;
  }
  .product,
  .iproduct {
    height: 270px !important;
  }
  .swiper_wrapper {
    width: 100% !important;
    padding-left: 0 !important;
    padding-right: 0 !important;
    height: 270px !important;
  }
  .swiper-slide {
    width: 100% !important;
    height: auto !important;
  }
}
</style>